<lv-uiartefakt-container [uiArtefakte]="uiArtefakt?.UIArtefakt"></lv-uiartefakt-container>
